import { Field } from 'react-final-form';
import { FormFormattedField } from 'components/Form';
import { normalizeFormattedField } from 'utils';

type Props = {
  vehicleId: number;
};

export const BlueBookField = ({ vehicleId }: Props) => {
  return (
    <Field
      label="Blue Book value"
      name="blueBookValue"
      component={FormFormattedField}
      prefix="$"
      thousandSeparator
      parse={normalizeFormattedField}
      styleVariant="filled"
    />
  );
};
